module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-five.de05311b.png";